import React from 'react';
import { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import CheckBoxInput from '../../../../../Components/CheckBoxInput';
import InputConfig from '../../../../../Components/InputConfig';

//mui imports====
import useCommonStyles from '../../../../../commonStyles';
import { Divider, Grid, Paper } from '@mui/material';
import PageHeading from '../../../../../Components/PageHeading';
import OverlayClickBlockerPreview from './OverlayClickBlockerPreview';

//===============

const OverlayClickBlockerConfig = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Overlay Click Blocker Config"
				headingPath={['Dashboard', 'Framerate', 'Format Data', 'Overlay Click Blocker']}
				description="Adds click blocker as an overlay over video player for blocking wrong clicks on ad creative"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid
				container
				spacing={1}
				style={{ width: '90%', paddingBottom: '3rem', marginLeft: '4rem', marginTop: '1rem' }}
			>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData + '.enabled'}
						label="enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ marginTop: '5rem', width: 'fit-content' }}
					/>
				</Grid>
				<Divider style={{ width: '100%', margin: '2rem 0 3rem' }} />
				<Grid item xs={12} style={{ display: 'flex', gap: '3rem' }}>
					<Grid item xs={3}>
						<InputConfig
							inputType="number"
							editable={!!rawConfig[keyData + '.enabled']}
							label="Border Thickness (%)"
							keyData={keyData + '.widthPercentage'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							inputType="number"
							editable={!!rawConfig[keyData + '.enabled']}
							label="Top Overlay Width (%)"
							keyData={keyData + '.topLengthPercentage'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							inputType="number"
							editable={!!rawConfig[keyData + '.enabled']}
							label="Left Overlay Height (%)"
							keyData={keyData + '.leftHeightPercentage'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>
					<Grid item xs={3}>
						<InputConfig
							inputType="number"
							editable={!!rawConfig[keyData + '.enabled']}
							label="Right Overlay Height (%)"
							keyData={keyData + '.rightHeightPercentage'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</Grid>
				</Grid>
				{rawConfig[keyData + '.enabled'] && (
					<Grid item style={{ marginTop: '2rem', width: '100%' }}>
						<OverlayClickBlockerPreview keyData={keyData} />
					</Grid>
				)}
			</Grid>
		</Paper>
	);
};
export default OverlayClickBlockerConfig;
